<template>
  <div>
    <div class="swiper-container-kb">
      <swiper :options="swiperOptions">
        <swiper-slide>
          <div class="swiper-box-kb bg-image2">
            <div class="swiper-box-text-h swiper-box-text1">
              <p style="margin-bottom: 18px">
                <span style="border-bottom: 4px solid #FF8C00; padding: 4px">好设备</span>
                <span>，就该用好线</span>
              </p>
              <h3 class="font-bold text-white leading-tight text-shadow mb-4" style="letter-spacing: 20px;">
                一六八线缆
                <br />打造电线电缆新标准
              </h3>
              <h4 class="text-white/90 leading-tight text-shadow mb-4" style="letter-spacing: 6px;opacity: 0.8;">Creating new standards</h4>
              <div class="text-white/80 mg-20 flex items-center justify-start text-sm">
                <div class="flex flex-col items-center mr-10">
                  <img src="@/assets/images/changjia.webp" style="width: 30px" />
                  <p>厂家直供</p>
                </div>
                <div class="flex flex-col items-center mr-10">
                  <img src="@/assets/images/zhiliang.webp" style="width: 30px" />
                  <p>质量可靠</p>
                </div>
                <div class="flex flex-col items-center mr-10">
                  <img src="@/assets/images/guige2.webp" style="width: 30px" />
                  <p>规格多样</p>
                </div>
                <div class="flex flex-col items-center mr-10">
                  <img src="@/assets/images/fuwu.webp" style="width: 30px" />
                  <p>贴心服务</p>
                </div>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-box-kb bg-image3">
            <div class="swiper-box-text-h swiper-box-text3">
              <h3 class="font-bold text-white leading-tight text-shadow mb-4" style="letter-spacing: 20px;">提供完善的解决方案</h3>
              <h4 class="text-white/90 leading-tight text-shadow mb-4" style="letter-spacing: 6px;opacity: 0.8;">Provide prefect solutions</h4>
              <p
                class="text-white/80 mb-8 max-w-2xl swiper-desc-k"
              >公司产品种类齐全，聚氯乙烯绝缘电力电缆、控制电缆、各种矿用电缆、阻燃电缆、低烟无卤电缆、高压电缆、铝合金电缆、矿物质电缆，并可根据客户需求，设计和生产各种技术含量高、工艺难度大的电线电缆。</p>
              <div
                style="
                  letter-spacing: 4px;
                  cursor: pointer;
                  display: inline-block;
                "
                class="px-8 py-3 bg-primary/60 text-white font-medium rounded-md transition-colors duration-300 shadow-lg hover:shadow-xl"
                @click="goPath('/productp')"
              >了解我们的产品</div>

              <a
                style="margin-left: 20px;"
                @click="goPath('/message')"
                class="px-8 py-3 bg-white/10 backdrop-blur-sm text-white font-medium rounded-md border border-white/30 hover:bg-white/20 hover:text-primary transition-colors duration-300"
              >联系我们</a>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="swiper-box-kb bg-image4">
            <div class="swiper-box-text-h">
              <h3 class="font-bold text-white leading-tight text-shadow mb-4" style="letter-spacing: 20px;">创新铸就高品质</h3>
              <h4
                class="text-white/90 leading-tight text-shadow mb-4"
                style="letter-spacing: 6px;opacity: 0.8;"
              >Innovation creates high quality</h4>
              <p
                class="text-white/80 mb-8 max-w-2xl swiper-desc-k"
              >公司产品种类齐全，聚氯乙烯绝缘电力电缆、控制电缆、各种矿用电缆、阻燃电缆、低烟无卤电缆、高压电缆、铝合金电缆、矿物质电缆，并可根据客户需求，设计和生产各种技术含量高、工艺难度大的电线电缆。</p>
              <div
                style="
                  letter-spacing: 4px;
                  cursor: pointer;
                  display: inline-block;
                "
                class="px-8 py-3 bg-primary/60 text-white font-medium rounded-md transition-colors duration-300 shadow-lg hover:shadow-xl"
                @click="goPath('/productp')"
              >查看更多</div>
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-next" slot="button-next"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
      </swiper>
    </div>
    <!-- 关于我们 -->
    <section id="about" class="py-20 bg-white">
      <div class="container mx-auto px-4 md:px-6">
        <div class="text-center mb-16 fade-in-section">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-4">关于河南一六八线缆有限公司</h2>
          <div class="w-20 h-1 bg-primary mx-auto mb-6"></div>
          <p class="text-dark/70 max-w-3xl mx-auto">聚焦产品品质与效益深耕，以匠心打造电缆行业技术与标准双标杆，驱动企业成为全球线缆领域的价值典范</p>
        </div>

        <div class="grid md:grid-cols-2 gap-12 items-center">
          <div class="relative fade-in-section slide-in-left">
            <img src="/case/company.webp" alt="关于我们" class="w-full h-auto rounded-lg shadow-xl" />
            <div class="absolute -bottom-6 -right-6 bg-primary text-white p-6 rounded-lg shadow-lg md:block">
              <p class="text-4xl font-bold">30+</p>
              <p class="text-sm">年行业经验</p>
            </div>
          </div>

          <div class="fade-in-section slide-in-right">
            <h3 class="text-2xl font-bold text-dark mb-6">我们的使命</h3>
            <p
              class="text-dark/70 mb-6"
            >肩负现代工业生命线的构筑使命，为自动化控制、智能建筑、能源分配等领域提供高可靠性电缆产品。以安全标准为基石、以创新技术为驱动，不仅保障设备稳定运行，更致力于推动电缆行业向绿色、智能、高效方向升级，成为全球关键基础设施连接的核心赋能者。</p>

            <div class="grid grid-cols-2 gap-6 mb-8">
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                  <i class="iconfont icon-zhiliangpingfen text-primary text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold text-dark mb-2">质量保证</h4>
                  <p class="text-dark/70 text-sm">从原材料溯源到成品交付，构建 "六重质检防线"</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                  <i class="iconfont icon-fuwurenyuan text-primary text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold text-dark mb-2">客户至上</h4>
                  <p class="text-dark/70 text-sm">以 "客户需求零时差响应" 为准则，1 小时内快速响应咨询</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                  <i class="iconfont icon-zhuanyezhuanyeke text-primary text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold text-dark mb-2">专业团队</h4>
                  <p class="text-dark/70 text-sm">由行业专家和技术精英组成的专业团队</p>
                </div>
              </div>
              <div class="flex items-start">
                <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                  <i class="iconfont icon-changjia2 text-primary text-xl"></i>
                </div>
                <div>
                  <h4 class="font-bold text-dark mb-2">多样化选择</h4>
                  <p class="text-dark/70 text-sm">规格齐全 · 生产实力支撑 "定制"</p>
                </div>
              </div>
            </div>

            <a href="#" class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors duration-300">
              了解更多关于我们的故事
              <i class="fa fa-long-arrow-right ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务内容 -->
    <section id="services" class="py-20 bg-light">
      <div class="container mx-auto px-4 md:px-6">
        <div class="text-center mb-16 fade-in-section">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-4">我们的产品</h2>
          <div class="w-20 h-1 bg-primary mx-auto mb-6"></div>
          <p
            class="text-dark/70 max-w-3xl mx-auto"
          >公司通过实施自动化、高端化、国际化战略，优化调整产业结构，不断提高自身产品的质量和效益，努力把公司建设成为管理先进、技术密集、品牌卓著的优秀企业。公司先后通过了ISO9001质量管理体系认证、ISO14001环境管理体系认证、OHSAS18001职业健康安全管理体系认证。</p>
        </div>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- 服务项目1 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.1s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/product/446ea399af05d311fd3b4ff92f6d73cb_800x800.webp"
                alt="布电线产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">布电线</h3>
              <p class="text-dark/70 text-sm mb-4">适用于建筑、家居等场所的通用布线，具有安全可靠、传输性能稳定等特点。</p>
              <a
                @click="goPath('/commonp?type=13')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>

          <!-- 服务项目2 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.2s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/dianlidianlan/ZCYJV 3X120+2X70copy.webp"
                alt="电力电缆产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">电力电缆</h3>
              <p class="text-dark/70 text-sm mb-4">用于电力传输和分配的电缆，具有高导电性能和良好的绝缘效果。</p>
              <a
                @click="goPath('/commonp?type=14')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>

          <!-- 服务项目3 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.3s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/product/f27221fac6672fba401256fa929df913_800x800.webp"
                alt="低烟无卤电缆产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">低烟无卤电缆</h3>
              <p class="text-dark/70 text-sm mb-4">环保型电缆，燃烧时烟雾少、无卤素释放，适用于高层建筑、地铁等场所。</p>
              <a
                @click="goPath('/commonp?type=17')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>

          <!-- 服务项目4 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.4s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/product/e81473357d6aa2f8c6c297b97466eed0_800x800.webp"
                alt="控制电缆产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">控制电缆</h3>
              <p class="text-dark/70 text-sm mb-4">用于电气控制系统的电缆，具有良好的抗干扰性能和信号传输稳定性。</p>
              <a
                @click="goPath('/commonp?type=16')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>

          <!-- 服务项目5 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.5s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/product/1679e7a3de72c612a15590500609aa27_800x800.webp"
                alt="高压电缆产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">高压电缆</h3>
              <p class="text-dark/70 text-sm mb-4">适用于高压电力传输的专用电缆，具有优异的绝缘性能和机械强度。</p>
              <a
                @click="goPath('/commonp?type=18')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>

          <!-- 服务项目6 -->
          <div
            class="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 fade-in-section overflow-hidden group"
            style="transition-delay: 0.6s"
          >
            <div class="w-full h-48 overflow-hidden relative">
              <img
                src="/product/54d63c0f190ef9e03b537425937fbb7a_800x800.webp"
                alt="矿物质电缆产品图片"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              ></div>
            </div>
            <div class="p-6">
              <h3 class="text-xl font-bold text-dark mb-3">矿物质电缆</h3>
              <p class="text-dark/70 text-sm mb-4">采用矿物质绝缘材料的防火电缆，适用于高温、防火要求高的特殊环境。</p>
              <a
                @click="goPath('/commonp?type=22')"
                class="inline-flex items-center text-primary font-medium hover:text-primary/80 transition-colors"
              >
                查看详情
                <i class="fa fa-arrow-right ml-2 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 案例展示 -->
    <section id="cases" class="py-20 bg-white">
      <div class="container mx-auto px-4 md:px-6">
        <div class="text-center mb-16 fade-in-section">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-4">成功案例</h2>
          <div class="w-20 h-1 bg-primary mx-auto mb-6"></div>
          <p class="text-dark/70 max-w-3xl mx-auto">广泛应用于工业自动化、智能建筑、能源系统及机械设备的连接，以高品质电缆为载体，为客户提供从信号传输到电力分配的全周期可靠性保障。</p>
        </div>

        <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- 案例1 -->
          <div class="group rounded-xl overflow-hidden shadow-lg fade-in-section slide-in-left" style="transition-delay: 0.1s">
            <div class="relative overflow-hidden">
              <img
                src="https://picsum.photos/id/242/600/400"
                alt="城市高压输电"
                class="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-dark/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
              >
                <div class="p-6">
                  <h3 class="text-xl font-bold text-white mb-2">城市高压输电</h3>
                  <p class="text-white/80 text-sm mb-4">多种铺设方式，为城市建设提供电力支持</p>
                </div>
              </div>
            </div>
            <div class="p-6">
              <div class="flex items-center mb-4">
                <span class="text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">能源电力行业</span>
              </div>
              <h3 class="text-lg font-bold text-dark mb-2 group-hover:text-primary transition-colors duration-300">城市高压输电</h3>
              <p class="text-dark/70 text-sm">通过用于架空或地下电缆隧道，减少长距离输电损耗</p>
            </div>
          </div>

          <!-- 案例2 -->
          <div class="group rounded-xl overflow-hidden shadow-lg fade-in-section slide-in-left" style="transition-delay: 0.2s">
            <div class="relative overflow-hidden">
              <img
                src="/case/case18.webp"
                alt="交通基建"
                class="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-dark/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
              >
                <div class="p-6">
                  <h3 class="text-xl font-bold text-white mb-2">交通基建</h3>
                  <p class="text-white/80 text-sm mb-4">通过电缆沟或桥架敷设，为桥上变电站、服务区供电，实现长距离电力传输。</p>
                </div>
              </div>
            </div>
            <div class="p-6">
              <div class="flex items-center mb-4">
                <span class="text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">建筑业</span>
              </div>
              <h3 class="text-lg font-bold text-dark mb-2 group-hover:text-primary transition-colors duration-300">交通基建</h3>
              <p class="text-dark/70 text-sm">沿桥墩预埋管道敷设，为桥上路灯、广告牌等设备供电。</p>
            </div>
          </div>

          <!-- 案例3 -->
          <div class="group rounded-xl overflow-hidden shadow-lg fade-in-section slide-in-left" style="transition-delay: 0.3s">
            <div class="relative overflow-hidden">
              <img
                src="/case/case10.webp"
                alt="厂区建设"
                class="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
              />
              <div
                class="absolute inset-0 bg-gradient-to-t from-dark/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end"
              >
                <div class="p-6">
                  <h3 class="text-xl font-bold text-white mb-2">厂区建设</h3>
                  <p class="text-white/80 text-sm mb-4">实现基础供电、高负荷供电与智能化集成</p>
                </div>
              </div>
            </div>
            <div class="p-6">
              <div class="flex items-center mb-4">
                <span class="text-xs font-medium text-primary bg-primary/10 px-3 py-1 rounded-full">民用建筑</span>
              </div>
              <h3 class="text-lg font-bold text-dark mb-2 group-hover:text-primary transition-colors duration-300">厂区建设</h3>
              <p class="text-dark/70 text-sm">支撑入户电力系统、家居弱电系统、照明与家电配电等多场景</p>
            </div>
          </div>
        </div>

        <div class="text-center mt-12 fade-in-section">
          <a
            href="#"
            class="inline-block px-8 py-3 bg-primary text-white font-medium rounded-md hover:bg-primary/90 transition-colors duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
          >查看更多案例</a>
        </div>
      </div>
    </section>

    <section id="certificates" class="py-20 bg-light">
      <div class="container mx-auto px-4 md:px-6">
        <!-- 标题区域 -->
        <div class="text-center mb-16 fade-in-section">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-4">企业资质证书</h2>
          <div class="w-20 h-1 bg-primary mx-auto mb-6"></div>
          <p class="text-dark/70 max-w-3xl mx-auto">权威认证加持，彰显专业实力与品质承诺</p>
        </div>

        <!-- Swiper轮播区域 -->
        <div class="certificate-swiper relative">
          <!-- 轮播容器 -->
          <swiper :options="swiperOption" ref="certificateSwiper" class="w-full">
            <!-- 轮播项 -->
            <swiper-slide v-for="(cert, index) in certificates" :key="index">
              <div class="certificate-slide-container">
                <!-- 证书项容器 -->
                <div class="certificate-item">
                  <!-- 图片容器（核心居中层） -->
                  <div class="certificate-img-wrapper">
                    <img :src="cert.imgUrl" :alt="cert.name" class="certificate-img" />
                  </div>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <!-- 左右导航按钮 -->
          <div class="absolute top-1/2 left-0 -translate-y-1/2 z-10">
            <button
              @click="$refs.certificateSwiper.swiper.slidePrev()"
              class="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-colors duration-300 ml-2 md:ml-0"
            >
              <i class="iconfont icon-angle-double-left text-xl"></i>
            </button>
          </div>
          <div class="absolute top-1/2 right-0 -translate-y-1/2 z-10">
            <button
              @click="$refs.certificateSwiper.swiper.slideNext()"
              class="w-12 h-12 rounded-full bg-white shadow-lg flex items-center justify-center text-primary hover:bg-primary hover:text-white transition-colors duration-300 mr-2 md:mr-0"
            >
              <i class="iconfont icon-angle-double-right text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- 数据统计 -->
    <section class="py-16 bg-primary">
      <div class="container mx-auto px-4 md:px-6">
        <div class="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
          <div class="fade-in-section">
            <div class="text-4xl font-bold text-white mb-2 counter" data-target="500">500</div>
            <p class="text-white/80">企业客户</p>
          </div>
          <div class="fade-in-section" style="transition-delay: 0.2s">
            <div class="text-4xl font-bold text-white mb-2 counter" data-target="800">1000</div>
            <p class="text-white/80">成功项目</p>
          </div>
          <div class="fade-in-section" style="transition-delay: 0.4s">
            <div class="text-4xl font-bold text-white mb-2 counter" data-target="98">90</div>
            <p class="text-white/80">客户满意度 (%)</p>
          </div>
          <div class="fade-in-section" style="transition-delay: 0.6s">
            <div class="text-4xl font-bold text-white mb-2 counter" data-target="150">120</div>
            <p class="text-white/80">专业团队</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section id="contact" class="py-20 bg-light">
      <div class="container mx-auto px-4 md:px-6">
        <div class="text-center mb-16 fade-in-section">
          <h2 class="text-[clamp(1.5rem,3vw,2.5rem)] font-bold text-dark mb-4">联系我们</h2>
          <div class="w-20 h-1 bg-primary mx-auto mb-6"></div>
          <p class="text-dark/70 max-w-3xl mx-auto">无论您有任何问题或需求，我们都很乐意倾听并为您提供专业的解答和服务。</p>
        </div>

        <div class="grid md:grid-cols-2 gap-12">
          <div class="fade-in-section slide-in-left">
            <div class="bg-white p-8 rounded-xl shadow-lg">
              <tianmap></tianmap>
            </div>
          </div>

          <div class="fade-in-section slide-in-right">
            <div class="bg-white p-8 rounded-xl shadow-lg mb-8" style="padding-bottom:104px">
              <h3 class="text-xl font-bold text-dark mb-6">联系方式</h3>
              <div class="space-y-6">
                <div class="flex items-start">
                  <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <i class="iconfont icon-changjia1 text-primary text-xl"></i>
                  </div>
                  <div>
                    <h4 class="font-bold text-dark mb-1">厂区地址</h4>
                    <p class="text-dark/70">武陟县詹店新区昌平路3号</p>
                  </div>
                </div>
                <div class="flex items-start">
                  <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <i class="iconfont icon-dianhua1 text-primary text-xl"></i>
                  </div>
                  <div>
                    <h4 class="font-bold text-dark mb-1">联系电话</h4>
                    <p class="text-dark/70">0371-65555168</p>
                  </div>
                </div>
                <div class="flex items-start">
                  <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <i class="iconfont icon-youxiang1 text-primary text-xl"></i>
                  </div>
                  <div>
                    <h4 class="font-bold text-dark mb-1">电子邮箱</h4>
                    <p class="text-dark/70">861333640@qq.com</p>
                  </div>
                </div>
                <div class="flex items-start">
                  <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <i class="iconfont icon-rencai1 text-primary text-xl"></i>
                  </div>
                  <div>
                    <h4 class="font-bold text-dark mb-1">工作时间</h4>
                    <p class="text-dark/70">周一至周日: 9:00 - 18:00</p>
                  </div>
                </div>
                <div class="flex items-start">
                  <div class="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4 flex-shrink-0">
                    <i class="iconfont icon-weixin text-primary text-xl"></i>
                  </div>
                  <div>
                    <h4 class="font-bold text-dark mb-1">微信</h4>
                    <p class="text-dark/70">15837161168</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import tianmap from '@/components/tianmap.vue'
function fn() {
  const fadeElements = document.querySelectorAll('.fade-in-section, .slide-in-left, .slide-in-right')

  fadeElements.forEach(element => {
    const elementTop = element.getBoundingClientRect().top
    const elementVisible = 150

    if (elementTop < window.innerHeight - elementVisible) {
      element.classList.add('is-visible')
    }
  })
}
export default {
  components: {
    swiper,
    swiperSlide,
    tianmap
  },
  data() {
    return {
      swiperOptions: {
        // Optional parameters
        loop: true,
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        // autoplay:false,
        // pagination: {
        //   el: ".swiper-pagination",
        // },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      // 证书数据
      certificates: [
        {
          imgUrl: '/honernew/11.webp', // 替换为实际图片路径
          name: 'ISO 9001质量管理体系认证'
        },
        {
          imgUrl: '/honernew/13.webp',
          name: 'ISO 14001环境管理体系认证'
        },
        {
          imgUrl: '/honernew/15.webp',
          name: 'OHSAS 18001职业健康安全认证'
        },
        {
          imgUrl: '/honernew/3c.webp',
          name: 'CCC国家强制性产品认证'
        },
        {
          imgUrl: '/honernew/3c2.webp',
          name: 'CCC国家强制性产品认证'
        },
        {
          imgUrl: '/honernew/20250719164701.webp',
          name: '营业执照'
        }
      ],
      // Swiper配置
      swiperOption: {
        // 显示3个slide
        slidesPerView: 3,
        // 居中显示
        centeredSlides: true,
        // 间距
        spaceBetween: 20,
        // 循环播放
        loop: true,
        // 自动播放
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        effect: 'slide',
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 10,
            coverflowEffect: {
              scale: 1 // 移动端不缩放
            }
          }
        }
      }
    }
  },
  computed: {},
  methods: {
    goPath(path) {
      this.$router.push(path)
    }
  },
  mounted() {
    window.addEventListener('scroll', fn)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', fn)
  }
}
</script>

<style lang="less" scoped>
.swiper-container-kb {
  width: 100%;
  background-color: #eee;
  position: relative;
  height: 100vh;
  overflow: hidden;
  .swiper-container {
    width: 100%;
    height: 100%;
  }
  .swiper-image-kb {
    object-fit: cover;
    max-width: 100%;
  }
  .swiper-box-kb {
    width: 100%;
    background-color: rgb(236, 234, 235);
    height: 100vh;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .bg-image1 {
    background-image: url('./../../assets/images/swiper1.webp');
  }
  .bg-image2 {
    background-image: url('./../../assets/images/swiper2.webp');
  }
  .bg-image3 {
    background-image: url('./../../assets/images/swiper3.webp');
  }
  .bg-image4 {
    background-image: url('./../../assets/images/swiper4.webp');
  }
  .swiper-main-image {
    position: absolute;
  }
  .swiper-image1 {
    right: 20%;
    bottom: -50px;
  }
  .swiper-image2 {
    left: 20%;
    bottom: -210px;
  }
  .swiper-image3 {
    right: 20%;
    bottom: -100px;
  }

  .swiper-box-text-h {
    z-index: 2;
    position: absolute;
    right: 15%;
    top: 50%;
    transform: translateY(-50%);
    font-size: large;
    text-align: right;
    h3 {
      font-size: xx-large;
      line-height: 40px;
      letter-spacing: 2px;
    }
    h4 {
      margin-top: 16px;
      margin-bottom: 20px;
      font-weight: 500;
      letter-spacing: 2px;
    }
    .swiper-desc-k {
      font-size: small;
      width: 440px;
      font-size: 16px;
      letter-spacing: 2px;
    }
  }

  .swiper-box-text1 {
    text-align: left;
    left: 15%;
  }
  .swiper-box-text3 {
    text-align: left;
    left: 15%;
  }
}
@media (max-width: 768px) {
  .swiper-container-kb .swiper-box-text-h {
    right: 0;
    top: 120px;
    .swiper-box-text1 {
      text-align: left;
      left: 10px;
    }
    .swiper-box-text3 {
      text-align: left;
      left: 10px;
    }
  }
  .swiper-box-text-h .swiper-desc-k {
    width: 100%;
  }
}

@media (max-width: 576px) {
  .swiper-container-kb .swiper-box-text-h {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    right: 0;
    top: 120px;
    transform: translateY(0);
    h3 {
      font-size: 20px;
    }
    .swiper-desc-k {
      width: 100%;
    }
  }
  .swiper-container-kb .swiper-box-text3 {
    text-align: left;
    left: 0px;
  }
  .swiper-container-kb .swiper-box-text1 {
    text-align: left;
    left: 0px;
  }
}

.carousel {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.carousel {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.carousel-slide {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 1.5s ease-in-out;
  background-size: cover;
  background-position: center;
}

.carousel-slide.active {
  opacity: 1;
}

.nav-scrolled {
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.fade-in-section {
  opacity: 0;
  transform: translateY(20px);
  transition: opacity 0.6s ease-out, transform 0.6s ease-out;
}

.fade-in-section.is-visible {
  opacity: 1;
  transform: translateY(0);
}

.slide-in-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.slide-in-right {
  opacity: 0;
  transform: translateX(50px);
  transition: opacity 0.8s ease-out, transform 0.8s ease-out;
}

.slide-in-left.is-visible,
.slide-in-right.is-visible {
  opacity: 1;
  transform: translateX(0);
}

.text-shadow {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.certificate-swiper {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.certificate-slide-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  padding: 0 20px;
}

.certificate-item {
  width: 100%;
  max-width: 400px;
  transition: all 0.5s ease;
  text-align: center;
}

/* 核心：图片容器居中样式 */
.certificate-img-wrapper {
  width: 100%;
  height: 400px; /* 固定高度，确保所有图片容器尺寸一致 */
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

/* 图片自身样式 */
.certificate-img {
  max-width: 100%; /* 不超过容器宽度 */
  max-height: 100%; /* 不超过容器高度 */
  object-fit: contain; /* 保持比例，无拉伸 */
}
</style>
